module.exports = __webpack_public_path__ + "static/img/page_01.381885ed.png";